
import * as Configuration from '../../../app.constants.js';

export class AccountsService {
  constructor($http, $q, $translate) {
    this.$http = $http;
    this.$q = $q;
    this.$translate = $translate;
  }

  // Information
  getAccountInfo(companyId, siteId) {
    return this.$http.get(Configuration.constants.baseUrl +
      'api/1.0/companies/' + companyId +
      '/sites/' + siteId);
  }

  updateAccountInfo(companyId, site, key) {
    return this.$http.put(Configuration.constants.baseUrl + 'api/1.0/companies/' + companyId + '/sites/' + site.id, {
      [key]: site[key]
    });
  }

  // Authorization
  getAuthLog(companyId, siteId) {
    return this.$http.get(Configuration.constants.baseUrl +
      'api/1.0/companies/' + companyId +
      '/sites/' + siteId + '/authorization-log');
  }

  authAccount(companyId, siteId) {
    return this.$http.get(Configuration.constants.baseUrl +
      'api/1.0/companies/' + companyId +
      '/sites/' + siteId + '/authorization');
  }

  // Inmessage allowed domains
  getWebchatAllowedDomains(companyId, siteId) {
    return this.$http.get(Configuration.constants.baseUrl +
      'api/1.0/companies/' + companyId +
      '/webchat/' + siteId + '/allowed-domains');
  }

  updateWebchatAllowedDomains(companyId, siteId, allowedDomains) {
    return this.$http.put(Configuration.constants.baseUrl +
      'api/1.0/companies/' + companyId +
      '/webchat/' + siteId + '/allowed-domains',
      {
        'allowed_domains': allowedDomains
      });
  }

  getWhatsappProfile(companyId, siteId) {
    return this.$http.get(Configuration.constants.baseUrl +
      'api/1.0/companies/' + companyId +
      '/sites/' + siteId + '/whatsapp/profile');
  }

  setWhatsappProfile(companyId, siteId, data) {
    return this.$http.put(Configuration.constants.baseUrl +
      'api/1.0/companies/' + companyId +
      '/sites/' + siteId + '/whatsapp/profile', data);
  }

  removeWhatsappProfilePhoto(companyId, siteId) {
    return this.$http.delete(Configuration.constants.baseUrl +
      'api/1.0/companies/' + companyId +
      '/sites/' + siteId + '/whatsapp/profile/photo');
  }

  // Conversations
  getAccountConversationConfig(companyId, siteId) {
    return this.$http.get(Configuration.constants.baseUrl +
      'api/1.0/companies/' + companyId +
      '/sites/' + siteId + '/conversations');
  }

  // Redirects
  redirectToAccountsPage($state) {
    $state.go('auth.alcmeon.fuse.parameters.accounts', {
      companyId: $state.params.companyId
    });
  }

  redirectToAddAccount($state) {
    $state.go('auth.alcmeon.fuse.parameters.add-account', {
      companyId: $state.params.companyId,
    });
  }

  hrefAccountInfo($state, accountId) {
    return Configuration.constants.frontendBaseUrl + $state.href('auth.alcmeon.fuse.account-edit') + accountId;
  }

  static AccountsFactory($http, $q, $translate) {
    return new AccountsService($http, $q, $translate);
  }
}

AccountsService.AccountsFactory.$inject = ['$http', '$q', '$translate'];
